import React, { useState } from 'react';
import { Container, Row, Col, } from 'react-bootstrap';
import Logo from '../assets/images/logo-icon.svg'
import Logo1 from '../assets/images/logo.png'
import Lock from '../assets/images/lock.png'
import CustomButton from '../common/CustomButton';
import { _apiUrls } from '../utils/endpoints/apiUrls';
import { apiRequest } from '../utils/config/apiRequest';
import TextField from '../common/TextFeild';
import { useParams } from 'react-router-dom';

const ResetPassword = () => {

    const { token } = useParams();

    const [state, setState] = useState({
        newPassword: '',
        confirmPassword: '',
    });
    const [error, setError] = useState('');

    // Get the last segment of the URL (token)
    // const path = window.location.pathname;
    // const segments = path.split('/').filter(Boolean);
    // const token = segments[segments.length - 1];

    const resetPassword = async () => {
        if (!state.newPassword || !state.confirmPassword) {
            setError('Both fields are required.');
            return;
        }

        if (state.newPassword !== state.confirmPassword) {
            setError('Passwords do not match.');
            return;
        }
        const reqdata = {
            password: state?.newPassword,
            token: token,
        }
        const { status } = await apiRequest({
            endUrl: _apiUrls.resetpassword,
            method: 'POST',
            body: reqdata,
            showMsg: true
        })
        if (status) {
            setState({ newPassword: '', confirmPassword: '' })
            setError('');
        }
    }


    return (
        <>
            <Container fluid className="login-page">
                <Row className="vh-100">
                    {/* Left Section */}
                    <Col md={7} className="d-flex order-sm-1 order-2 flex-column justify-content-center align-items-center left-section py-4">
                        <img src={Logo} alt="Logo" className="mb-2 logo-img mt-auto" />
                        <h1>Just Push It.</h1>
                        <p>Stay informed instantly with our app!</p>
                        <footer className="mt-auto privacypolicy">
                            <span>© 2025 All rights Reserved</span>
                            <a href="/" className="privacypolicy" style={{ marginLeft: '60px' }}>Privacy Policy</a>
                        </footer>
                    </Col>

                    {/* Right Section */}
                    <Col md={5} className="align-items-start order-sm-2 order-1 px-sm-5 px-3 bg-white">
                        <Row className="px-4">
                            <Col md={12}>
                                <div className="mt-sm-5 mt-5">
                                    <img src={Logo1} alt="Mini Logo" className="logoimg" style={{ height: "60px" }} />
                                </div>

                            </Col>

                            <Col md={12}>
                                <div className="mt-sm-5 mt-4">
                                    <h2 className="heading">Welcome Back,</h2>
                                    <p className="subheading">Hey, Reset your password!</p>
                                </div>
                            </Col>

                            <Col md={12} className="mt-sm-4 mt-4 mb-sm-2 mb-3">
                                <p className='mb-1 login-input-label'>New Password <span style={{ color: 'red' }}>*</span></p>
                                <TextField
                                    icon={Lock}
                                    placeholder="Enter New Password"
                                    value={state.newPassword}
                                    onChange={(e) =>
                                        setState({ ...state, newPassword: e.target.value })
                                    }
                                />
                            </Col>

                            <Col md={12} className="mt-sm-3 mt-4 mb-sm-2 mb-3">
                                <p className='mb-1 login-input-label'>Confirm Password <span style={{ color: 'red' }}>*</span></p>
                                <TextField
                                    icon={Lock}
                                    placeholder="Confirm New Password"
                                    value={state.confirmPassword}
                                    onChange={(e) =>
                                        setState({ ...state, confirmPassword: e.target.value })
                                    }
                                />
                                {error && <p style={{ color: 'red', marginTop: 8 }}>{error}</p>}
                            </Col>

                        </Row>

                        <Row className='px-4'>
                            <Col md={12} className='mt-sm-3 mt-4 pb-5'>
                                <CustomButton variant="contained3"
                                    text={"Reset Password"}
                                    className='containebtn'
                                    onClick={resetPassword}
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>

        </>

    );
};

export default ResetPassword;
